/**
 * 企业子账号 API（P0-8 + 2026-08-21 后端校验加固）
 *
 * 后端路由（PRD §5.1.4）：
 *   POST   /api/v1/users/me/sub-accounts              创建子账号（仅企业客户 user_type=3 主账号）
 *   GET    /api/v1/users/me/sub-accounts              主账号列子账号
 *   PUT    /api/v1/users/me/sub-accounts/:id/disable  主账号禁用子账号
 *   PUT    /api/v1/users/me/sub-accounts/:id/enable   主账号启用子账号
 *
 * 错误码：
 *   3801 子账号数量已达上限（50）
 *   3802 用户名/手机号已占用
 *   3803 子账号不能再创建下级
 *   3804 子账号引用环
 *   3805 仅企业客户可创建子账号（非 user_type=3 主账号拒绝）
 */
import { get, post, put } from './http';

/** 子账号后端响应结构（model.User 投影） */
export interface SubAccount {
  id: number;
  username: string;
  phone: string;
  real_name: string;
  user_type: number;
  status: number; // 0 禁用 / 1 启用
  parent_user_id: number;
  is_sub_account: number;
  created_at: string;
  updated_at: string;
}

/** 创建子账号请求 */
export interface CreateSubAccountParams {
  username: string; // 4-64 字符
  password: string; // 8-64 字符
  phone: string; // 11 位手机号
  real_name?: string; // 最多 64 字符
  role_codes?: string[]; // 子账号独立配置角色，可选；最多 10 个
}

/** 创建子账号响应 */
export interface CreateSubAccountResult {
  sub_account_id: number;
  username: string;
}

/** 主账号列出自己的子账号（API 返回的 data 字段） */
export type ListSubAccountsResult = SubAccount[];

/** 创建子账号 */
export function createSubAccount(
  params: CreateSubAccountParams,
): Promise<CreateSubAccountResult> {
  return post<CreateSubAccountResult>('/users/me/sub-accounts', params);
}

/** 主账号列子账号 */
export function listSubAccounts(): Promise<ListSubAccountsResult> {
  return get<ListSubAccountsResult>('/users/me/sub-accounts');
}

/** 禁用子账号 */
export function disableSubAccount(subId: number): Promise<null> {
  return put<null>(`/users/me/sub-accounts/${subId}/disable`);
}

/** 启用子账号 */
export function enableSubAccount(subId: number): Promise<null> {
  return put<null>(`/users/me/sub-accounts/${subId}/enable`);
}